var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___cHc2d2",
  "Un": "AuthPageStyles.module__errorContainer___cHc2d2",
  "ik": "AuthPageStyles.module__errorIcon___cHc2d2",
  "gi": "AuthPageStyles.module__errorIconSvg___cHc2d2",
  "JU": "AuthPageStyles.module__errorTitle___cHc2d2",
  "kc": "AuthPageStyles.module__errorText___cHc2d2",
  "kL": "AuthPageStyles.module__container___cHc2d2",
  "TQ": "AuthPageStyles.module__entityHeader___cHc2d2",
  "Ep": "AuthPageStyles.module__entityDetails___cHc2d2",
  "Pp": "AuthPageStyles.module__entityText___cHc2d2",
  "j2": "AuthPageStyles.module__entityTitleWrapper___cHc2d2",
  "wD": "AuthPageStyles.module__entityTitle___cHc2d2",
  "N2": "AuthPageStyles.module__entityStats___cHc2d2",
  "So": "AuthPageStyles.module__entityStat___cHc2d2",
  "RS": "AuthPageStyles.module__onlineDot___cHc2d2",
  "FD": "AuthPageStyles.module__offlineDot___cHc2d2",
  "KA": "AuthPageStyles.module__statText___cHc2d2",
  "Wp": "AuthPageStyles.module__entityIconWrapper___cHc2d2",
  "fq": "AuthPageStyles.module__entityIcon___cHc2d2",
  "Ly": "AuthPageStyles.module__themeIconSpot___cHc2d2",
  "J3": "AuthPageStyles.module__themeIcon___cHc2d2",
  "Zd": "AuthPageStyles.module__form___cHc2d2",
  "ee": "AuthPageStyles.module__registrationNotice___cHc2d2",
  "Gr": "AuthPageStyles.module__bottomLink___cHc2d2",
  "fH": "AuthPageStyles.module__bottomLinkText___cHc2d2",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___cHc2d2",
  "cB": "AuthPageStyles.module__usernameHint___cHc2d2",
  "Jy": "AuthPageStyles.module__suggestionLink___cHc2d2",
  "LB": "AuthPageStyles.module__usernameError___cHc2d2",
  "$M": "AuthPageStyles.module__consentRow___cHc2d2",
  "t6": "AuthPageStyles.module__consentLabel___cHc2d2",
  "Rf": "AuthPageStyles.module__policyLink___cHc2d2",
  "ii": "AuthPageStyles.module__disabledContainer___cHc2d2",
  "aV": "AuthPageStyles.module__disabledText___cHc2d2",
  "ax": "AuthPageStyles.module__disabledSubtext___cHc2d2",
  "SO": "AuthPageStyles.module__disabledActions___cHc2d2",
  "ns": "AuthPageStyles.module__disabledActionLink___cHc2d2",
  "DD": "AuthPageStyles.module__title___cHc2d2",
  "Zo": "AuthPageStyles.module__giftIconContainer___cHc2d2",
  "ez": "AuthPageStyles.module__giftIcon___cHc2d2",
  "PM": "AuthPageStyles.module__entitySubtext___cHc2d2",
  "W$": "AuthPageStyles.module__subtext___cHc2d2",
};

module.exports = exports;
